import * as React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../../components/Layout"
import Seo from "../../components/Seo";

const CatalogItemPage = () => (
	<Layout>
		<Seo title="one" />

		<h2>one</h2>

		<div className="main--centerwrapper">
			<StaticImage
			src="../../images/catalog artwork/JRIVEST18 one front.jpg"
			alt="Jessellaneous - one - cover art"
			placeholder="blurred"
			layout="constrained"
			className="main--centered"
			imgClassName="img--bordered-small"
			width={500}
			/>
		</div>

		<h3>Prerelease note</h3>
		<p>
			To be released on October 30, 2025.
		</p>

		<h3>Words from Jesse</h3>
		<p>
			I created the <span className="bold">Jessellaneous</span> moniker
			(Jane came up with the name and I dug it—I was stuck on "Jesse Rivest Extras" which was relatively lame)
			specifically to release a cover version I had developed of the song, <span className="italic">Dive In</span>,
			originally released by Ryan Mack and Robert Grace.
			I realized I would have more releases upcoming that might be well suited to this new artist name, so I went for it.
			So, why <span className="italic">Dive In</span> and why Jessellaneous?
		</p>
		<p>
			<span className="italic">Dive In</span> was commissioned in early 2025 by a client named Isaac on the AirGigs platform
			(see <Link to="/hire/">Hire</Link> to know more about that type of work);
			Isaac was looking for a more stripped down, folky version of the song.
			I found myself really digging into the project and giving it all I had;
			I wondered if I might want to release my version of this song.
			Later in 2025 I began working with my friend, Murilo, on a different song he had started.
			I got right into that one, too, and realized that we certainly were going to be releasing this new song
			(that will come later—it's not part of this here release).
			Both of these new productions/songs were reasonably different from what I usually produce and release as Jesse Rivest;
			I realized I would like a new artist project/name for miscellaneous projects/releases that in any/some way fall outside of my usual trajectory.
		</p>
		<p>
			When I came back to listen to <span className="italic">Dive In</span>, I realized that the acoustic guitar was irritating me, so I re-recorded it.
			I mixed the song aggressively, going far beyond how I would normally treat one of my own songs.
			With the help of some external ears, I realized that I had gone way too hard on the snare drum and the drum special effects;
			in the end, I reduced those elements over several mixing iterations.
			I had mixed the song quite a few times, and ultimately decided to release two versions,
			appropriately named <span className="italic">surfaced</span> and <span className="italic">submerged</span>.
		</p>
		<p>
			See which version you like better; feel free to <Link to="/contact/">contact me</Link> and let me know your thoughts!
		</p>
		<h3>Track listing</h3>
		<ol>
			<li>
				Dive In - surfaced mix (3:28)<br />
				(Written by Robert Grace, Glenn Herlihy, Ryan Mcloughlin, and Jake Richardson)<br />
				&lt;ISWC missing&gt; - © Sentric Music Publishing (PRS) 2024<br />
				CA-6P8-25-00001 - © Jesse Rivest 2025 (PPL)
			</li>
			<li>
				Dive In - submerged mix (3:28)<br />
				(Written by Robert Grace, Glenn Herlihy, Ryan Mcloughlin, and Jake Richardson)<br />
				&lt;ISWC missing&gt; - © Sentric Music Publishing (PRS) 2024<br />
				CA-6P8-25-00002 - © Jesse Rivest 2025 (PPL)
			</li>
		</ol>
		<p>
			This recording: catalog number JRIVEST18, © Jesse Rivest 2025, All Rights Reserved<br />
			UPC/EAN: 0199999467519<br />
			Released: October 30, 2025
		</p>

		<h3>Credits</h3>
		<p>
			Produced, recorded, mixed, and mastered by Jesse Rivest at his Little Bakery Studio in Brasilia, DF, Brazil.<br />
			Song sung by Jesse Rivest.<br />
			Acoustic guitar performed by Jesse Rivest.<br />
			Electric guitar performed by Jesse Rivest.<br />
			Keyboard organ and organ bass performed by Jesse Rivest.<br />
			Drum programming by Jesse Rivest.
		</p>

		<h3>Special Thanks</h3>
		<p>
			Thanks to Jane Lino for being supportive, always.<br />
			Thanks to Jane, Murilo Fabrino, and Leonardo Schmidt for their ears and feedback.<br />
			Thanks to Isaac for the trust and confidence.
		</p>

		<h3>Extras</h3>

		<h4>About the front cover</h4>
		<p>
			Jane and I went to Taipu de Fora in 2020, right after the Maraú Peninsula opened up to tourism again during the pandemic.
			It was a wonderful trip. From the vantage point in the photo, on one particular day other than the one of the photo,
			we saw a mother humpback whale and her calf in the distance.
			Dunno if they were playing but it sure seemed like it.
			We would regularly come to this location at the appropriate tidal hour to see sea turtles in the surf.
			Before we left our chalet on this particular day, we quickly dismissed bringing the binoculars (something I generally would bring everywhere).
			After that day, we formed a saying: <span className="bold">never leave home without binoculars</span>.
			We have not been disappointed since.
		</p>

		<p>
			<Link to="../">Go back to Music Catalog</Link>
		</p>
	</Layout>
);

export default CatalogItemPage;
